{
  "metadata": {
    "id": "github-light",
    "name": "GitHub",
    "description": "Портировано из темы «GitHub» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "github.json",
      "project": "primer",
      "url": "https://github.com/primer/github-vscode-theme",
      "upstreamFile": "packages/ui/src/theme/themes/github.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 27.2,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.454,
      "paletteMaxS": 0.523,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.8,
      "syntaxVsTextMinDeltaE": 21.9,
      "chartsMinDeltaE": 28.7,
      "textSeparationDeltaE": 15.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "operator",
          "deltaE": 0.0
        },
        {
          "a": "number",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#0969da",
      "hover": "#085ec4",
      "active": "#0756b3",
      "foreground": "#ffffff",
      "muted": "#0969da80",
      "emphasis": "#0969da"
    },
    "surface": {
      "background": "#ffffff",
      "foreground": "#24292f",
      "muted": "#cfd1d2",
      "mutedForeground": "#444b53",
      "elevated": "#b8babc",
      "elevatedForeground": "#24292f",
      "raised": "#9c9fa2",
      "raisedForeground": "#24292f",
      "overlay": "#ffffff33",
      "subtle": "#e7e8e8"
    },
    "interactive": {
      "border": "#95979b",
      "borderHover": "#c2c3c5",
      "borderFocus": "#0969da",
      "selection": "#24292f24",
      "selectionForeground": "#24292f",
      "focus": "#0969da59",
      "focusRing": "#0969da47",
      "cursor": "#24292f",
      "hover": "#24292f17",
      "active": "#24292f24"
    },
    "status": {
      "error": "#cf222e",
      "errorForeground": "#ffffff",
      "errorBackground": "#cf222e1a",
      "errorBorder": "#cf222e59",
      "warning": "#9a6700",
      "warningForeground": "#ffffff",
      "warningBackground": "#9a67001a",
      "warningBorder": "#9a670059",
      "success": "#1a7f37",
      "successForeground": "#ffffff",
      "successBackground": "#1a7f371a",
      "successBorder": "#1a7f3759",
      "info": "#bc4c00",
      "infoForeground": "#ffffff",
      "infoBackground": "#bc4c001a",
      "infoBorder": "#bc4c0059"
    },
    "pr": {
      "open": "#1a7f37",
      "draft": "#525b64",
      "blocked": "#9a6700",
      "merged": "#1b7c83",
      "closed": "#cf222e"
    },
    "syntax": {
      "base": {
        "background": "#cfd1d2",
        "foreground": "#24292f",
        "comment": "#525b64",
        "keyword": "#ac1c26",
        "string": "#0756b3",
        "number": "#156065",
        "function": "#156065",
        "variable": "#983e00",
        "type": "#983e00",
        "operator": "#ac1c26"
      },
      "tokens": {
        "commentDoc": "#525b64",
        "stringEscape": "#ac1c26",
        "keywordImport": "#ac1c26",
        "storageModifier": "#ac1c26",
        "functionCall": "#156065",
        "method": "#156065",
        "variableProperty": "#156065",
        "variableOther": "#983e00",
        "variableGlobal": "#156065",
        "variableLocal": "#ac1c26",
        "parameter": "#983e00",
        "constant": "#156065",
        "class": "#983e00",
        "className": "#983e00",
        "interface": "#983e00",
        "struct": "#983e00",
        "enum": "#983e00",
        "typeParameter": "#983e00",
        "namespace": "#983e00",
        "module": "#ac1c26",
        "tag": "#ac1c26",
        "jsxTag": "#ac1c26",
        "tagAttribute": "#156065",
        "tagAttributeValue": "#0756b3",
        "boolean": "#156065",
        "decorator": "#ac1c26",
        "label": "#156065",
        "regexp": "#0756b3"
      }
    },
    "charts": {
      "series": [
        "#0969da",
        "#bc4c00",
        "#1a7f37",
        "#9a6700",
        "#cf222e"
      ]
    },
    "chat": {
      "background": "#ffffff",
      "userMessage": "#24292f",
      "userMessageBackground": "#b8babc",
      "assistantMessage": "#24292f",
      "assistantMessageBackground": "#cfd1d2",
      "timestamp": "#525b64",
      "divider": "#95979b",
      "typing": "#525b64"
    },
    "loading": {
      "spinner": "#0969da",
      "spinnerTrack": "#cfd1d2",
      "skeleton": "#cfd1d2",
      "shimmer": "#c5c7c8"
    },
    "tools": {
      "background": "#cfd1d2",
      "border": "#95979b",
      "headerHover": "#c6c9ca",
      "icon": "#0969da",
      "title": "#24292f",
      "description": "#525b64",
      "edit": {
        "added": "#1a7f37",
        "addedBackground": "#1a7f371a",
        "removed": "#cf222e",
        "removedBackground": "#cf222e1a",
        "modified": "#bc4c00",
        "modifiedBackground": "#bc4c001a",
        "lineNumber": "#525b64"
      }
    },
    "markdown": {
      "heading1": "#24292f",
      "heading2": "#24292f",
      "heading3": "#24292f",
      "heading4": "#24292f",
      "link": "#0969da",
      "linkHover": "#085ec4",
      "inlineCode": "#0756b3",
      "inlineCodeBackground": "#cfd1d2",
      "blockquote": "#525b64",
      "blockquoteBorder": "#95979b",
      "listMarker": "#0969dabf",
      "bold": "#24292f",
      "italic": "#24292fe6",
      "strikethrough": "#525b64",
      "hr": "#95979b"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#bf4843",
        "foreground": "#ffffff",
        "contrast": 4.97
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#8b593b",
        "foreground": "#ffffff",
        "contrast": 5.85
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d0a270",
        "foreground": "#000000",
        "contrast": 9.08
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#899044",
        "foreground": "#000000",
        "contrast": 6.14
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#abd476",
        "foreground": "#000000",
        "contrast": 12.41
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#55c651",
        "foreground": "#000000",
        "contrast": 9.58
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#428e52",
        "foreground": "#000000",
        "contrast": 5.22
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#76d3a9",
        "foreground": "#000000",
        "contrast": 11.66
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#74c5d1",
        "foreground": "#000000",
        "contrast": 10.65
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3f798c",
        "foreground": "#ffffff",
        "contrast": 4.86
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#364f88",
        "foreground": "#ffffff",
        "contrast": 7.98
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3a42b9",
        "foreground": "#ffffff",
        "contrast": 7.9
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#9b71c3",
        "foreground": "#000000",
        "contrast": 5.54
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b84abf",
        "foreground": "#000000",
        "contrast": 4.77
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#923674",
        "foreground": "#ffffff",
        "contrast": 7.0
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c57289",
        "foreground": "#000000",
        "contrast": 6.14
      }
    ]
  }
}
